module.exports = __webpack_public_path__ + "static/media/9.1.6cda66e1.png";